/**
 * @voltxampere/engine — Independent voltage source DC stamp
 *
 * A V source between `pos` and `neg` carrying value `V` adds an
 * augmented row/col `k = N + vSourceIndex(componentId)` and writes:
 *
 *   B[pos][k] = +1,   B[neg][k] = -1,
 *   C[k][pos] = +1,   C[k][neg] = -1,   (C ≡ Bᵀ)
 *   rhs[k] = V * sourceScale.
 *
 * `sourceScale` is the SPECS §3.7 source-stepping continuation
 * factor — the linear stamps multiply their value by it; nonlinear
 * stamps ignore it (only independent sources participate in source
 * stepping).
 *
 * Either terminal may be ground; the relevant cells are dropped by
 * `ctx.addY`. The augmented row's RHS entry always lands because
 * `k = N + j` is non-negative.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { defineDCStamp } from "../definition.js";
import { getTerminalNetId, getNumericParam } from "../terminal-utils.js";
export const voltageSourceDCStamp = (ctx, component) => {
    const v = getNumericParam(component, "voltage");
    const pos = ctx.nodeIndex(getTerminalNetId(component, "pos"));
    const neg = ctx.nodeIndex(getTerminalNetId(component, "neg"));
    const k = ctx.vSourceIndex(component.id);
    ctx.addY(pos, k, 1);
    ctx.addY(neg, k, -1);
    ctx.addY(k, pos, 1);
    ctx.addY(k, neg, -1);
    ctx.rhs[k] = (ctx.rhs[k] ?? 0) + v * ctx.sourceScale;
};
/** Independent V source: one augmented row carrying the branch current. */
export const voltageSourceDCStampDefinition = defineDCStamp("voltage-source", voltageSourceDCStamp, ["vsource"]);
//# sourceMappingURL=voltage-source.js.map